import { gspx } from '@rsos/gainsight';

export const trackJurisdictionDetailsAction = (action, irpVersion) => {
  gspx.trackCustomEvent('Admin JurisdictionDetails', {
    irpVersion,
    name: action,
    Category: 'Issue',
    'Launched date': new Date(),
  });
};

export const trackShapeFileVerified = (name, irpVersion) => {
  gspx.trackCustomEvent('Admin JurisdictionDetails', {
    irpVersion,
    name,
    Category: 'Issue',
    'Launched date': new Date(),
  });
};

export const trackSeekClarification = (name, irpVersion) => {
  gspx.trackCustomEvent('Admin JurisdictionDetails', {
    irpVersion,
    name,
    Category: 'Issue',
    'Launched date': new Date(),
  });
};
